import moment from "moment"
import * as PropTypes from "prop-types"
import React, { Component } from "react"
import DayPickerInput from "react-day-picker/DayPickerInput"
import { Button } from "semantic-ui-react"

import shop from "shop/shop"
import settingStore from "stores/settingStore"

const formatDate = date => {
  return moment( date ).format( "DD. MMMM YYYY" )
}


class DeliveryDatePicker extends Component {

  state = {
    DELAY_IN_DAYS:  1,
    hasInitialized: false
  }

  getDelay() {
    let { onChange, date } = this.props
    const mode = settingStore.get( "orderMode" )
    let DELAY_IN_DAYS = 1
    if ( mode !== "MODE_AVAILABLE" ) {
      let dates = shop.cart.products.filter( p => p.extras && p.extraValue.verfuegbarab !== "null" )
        .map( d => d.extraValue.verfuegbarab )

      let minDate = moment.min( dates.map( data => moment( data, "DD-MM-YYYY" ) ) )
      DELAY_IN_DAYS = Math.max( minDate.diff( moment(), "day" ), 1 )
      console.log( { minDate, orderAb: minDate.format( "DD-MM-YYYY" ), dates } )

      if ( dates.length === 0 ) {
        DELAY_IN_DAYS = 1
      }
      if ( !date ) {
        onChange( moment.max( moment().add( DELAY_IN_DAYS, "day" ), minDate ) )
      }
    }

    this.setState( { DELAY_IN_DAYS } )
    return DELAY_IN_DAYS
  }

  componentDidMount() {
    this.getDelay()
  }

  render() {
    let { onChange, date } = this.props
    let { DELAY_IN_DAYS } = this.state
    return <div className={"pb7"}>
      <div className={""}>
        {date &&
        <div>{moment( date, "DD.MM.YYYY" ).format( "dddd, DD. MMMM YYYY" )}</div>}
      </div>
      <DayPickerInput
        value={date}
        placeholder={translate("Ihr Terminwunsch")}
        formatDate={formatDate}
        dayPickerProps={{
          initialMonth: moment().add( DELAY_IN_DAYS, "day" ).toDate(),
          disabledDays: [
            {
              before: moment().add( DELAY_IN_DAYS, "day" ).toDate()
            }
          ]
        }}
        onDayChange={onChange}/>
      {date && <div className="dib pl3"><Button basic icon="close"
                                                onClick={() => onChange( "" )}/>
      </div>}
    </div>
  }
}

DeliveryDatePicker.propTypes = {
  onChange: PropTypes.any,
  date:     PropTypes.any
}

export default DeliveryDatePicker



// WEBPACK FOOTER //
// ./src/theme/arnoldsports/components/Date/DeliveryDatePicker.js